import {Box} from "@mui/material";
import {useNavigate, useParams, useLocation} from "react-router-dom";
import {
    OrganizationIdListRequest,
    useEetsDeviceByIdGetQuery,
    useEetsDeviceHistoryListQuery,
} from "../../../app/api/api";
import QueryErrorAlert from "../../../components/QueryErrorAlert";
import {useTranslation} from "react-i18next";
import React, {useMemo} from "react";
import {ContentTitle} from "../../../components/Layout/Page";
import {ErrorCode} from "../../../components/Layout/Page/types";
import ErrorPage from "../../../components/Layout/Page/ErrorPage";
import HistoryTable from "../../devices/historyTable/HistoryTable";
import {EetsDeviceHistoryEntry} from "../../../app/api/model/eetsDevice";
import EetsDeviceGeneralContent from "./EetsDeviceGeneralContent";
import TabSection from "../../../components/Layout/Page/TabSection";

export default function EetsDeviceDetails() {
    const {t} = useTranslation();
    const params = useParams();
    const location = useLocation();
    const id = Number.parseInt(params.eetsDeviceId || "0");
    const organizationId = Number.parseInt(params.organizationId || "0");
    const {data: eetsDevice, error} = useEetsDeviceByIdGetQuery({organizationId, id});
    const navigate = useNavigate();

    const initialTab = useMemo(() => {
        const fromHash = Number.parseInt((location.hash || "").replace("#", ""), 10);
        return Number.isFinite(fromHash) && fromHash >= 0 ? fromHash : 0;
    }, [location.hash]);
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        navigate(`#${newValue}`, {replace: true});
    };

    return (
        <Box>
            {eetsDevice ? (
                <>
                    <ContentTitle
                        titleKey="organizations_eetsDevices"
                        subtitle={eetsDevice?.id}
                        applySearchParams={false}
                        entry={eetsDevice}
                    />
                    <TabSection
                        title={t("generic_organizations")}
                        initialTab={initialTab}
                        onChange={handleChange}
                        tabs={[
                            {
                                label: t("generic_general"),
                                content: <EetsDeviceGeneralContent key="general" eetsDevice={eetsDevice} />,
                            },
                            {
                                label: t("organizations_eetsDevicesHistory"),
                                content: (
                                    <HistoryTable<EetsDeviceHistoryEntry, OrganizationIdListRequest>
                                        key="history"
                                        additionalRequestParams={{id, organizationId}}
                                        queryHook={useEetsDeviceHistoryListQuery}
                                        isEetsDevice={true}
                                    />
                                ),
                            },
                        ]}
                    />
                </>
            ) : (
                <ErrorPage code={ErrorCode.NOT_FOUND}>{error && <QueryErrorAlert error={error} />}</ErrorPage>
            )}
        </Box>
    );
}
